export const API_PATH_ApiAlertMgtmAlertConfigSearchGet = '/services/alerts-mgtm/apiAlertMgtmAlertConfigSearchGet';
